import get from 'lodash.get';

import { emptyArray } from '../../../default-props/empty';

export const selectLoadingState = (state) => get(state, 'isLoading', false);
export const selectionSectionStates = (state) => get(state, 'sectionStates', false);
export const selectReturnsFulfillmentPlanId = (state, props) => `return-${get(props, 'salesOrderId')}`;
export const selectIsLoadingRates = (state) => get(state, 'isLoadingRates');
export const selectSingleOrderDrawerModulesList = (state) => get(state, 'singleOrderDrawerModulesList', emptyArray);
export const selectMultiOrderDrawerModulesList = (state) => get(state, 'multiOrderDrawerModulesList', emptyArray);
export const selectIsValidatingAddress = (state) => get(state, 'isValidatingAddress');

export const selectSingleOrderInventoryInfo = (state) => get(state, 'inventoryInfo');

export const selectLastAppliedRecommendation = (state) => state?.lastAppliedRecommendation;
